import styled from "styled-components"
import React from "react"
import { OverlayTrigger, Popover } from "react-bootstrap"

import { QuestionEmptyIcon } from "client/components"


const PopoverStyled = styled(Popover)`
    background: ${(props) => props.theme.tablePopoverBackground};

    & > .popover-arrow {
        margin: 0;
    }

    & > .popover-arrow::before,
    & > .popover-arrow::after {
        border-left-color: "transparent";
        border-right-color: ${(props) => props.theme.tablePopoverBackground};
    }
`
const PopoverContentStyled = styled(Popover.Body)`
    color: ${(props) => props.theme.tablePopoverColor};
`
const HelpWrapper = styled.div`
    cursor: help;
    font-size: 16px;
    line-height: 16px;
    margin-left: 10px;
    color: ${(props) => props.theme.helpColor};
`


export interface HelpProps {
    text: string
}
export const Help = ({
    text,
}: HelpProps) => (
    <OverlayTrigger
        trigger={["hover", "focus"]}
        placement="right"
        overlay={(
            <PopoverStyled>
                <PopoverContentStyled>
                    { text }
                </PopoverContentStyled>
            </PopoverStyled>
        )}
    >
        <HelpWrapper>
            <QuestionEmptyIcon />
        </HelpWrapper>
    </OverlayTrigger>
)
